import React from 'react';
import styled, { css } from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { styleVariables } from '@lib/common'; // ─── Styled Components ────────────────────────────────────────────────────────

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var compactStyles = css(["width:180px;height:56px;padding:8px 10px;align-items:center;"]);
var richStyles = css(["width:240px;min-height:72px;padding:10px 12px;align-items:flex-start;"]);
var ItemWrapper = styled.div.withConfig({
  displayName: "attachment-itemcomponent__ItemWrapper",
  componentId: "sc-1ey21cr-0"
})(["display:inline-flex;box-sizing:border-box;border:1px solid #e0e4ef;border-radius:10px;background-color:#ffffff;position:relative;flex-shrink:0;cursor:", ";", ""], function (_ref) {
  var $clickable = _ref.$clickable;
  return $clickable ? 'pointer' : 'default';
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === 'rich' ? richStyles : compactStyles;
});
var IconContainer = styled.div.withConfig({
  displayName: "attachment-itemcomponent__IconContainer",
  componentId: "sc-1ey21cr-1"
})(["display:flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:8px;flex-shrink:0;margin-right:10px;color:", ";background-color:#f7f8fc;svg{font-size:18px;}img{width:18px;height:18px;display:block;object-fit:contain;}"], function (_ref3) {
  var $color = _ref3.$color;
  return $color;
});
var ContentColumn = styled.div.withConfig({
  displayName: "attachment-itemcomponent__ContentColumn",
  componentId: "sc-1ey21cr-2"
})(["display:flex;flex-direction:column;justify-content:center;flex:1;min-width:0;padding-right:20px;"]);
var TitleText = styled.div.withConfig({
  displayName: "attachment-itemcomponent__TitleText",
  componentId: "sc-1ey21cr-3"
})(["font-weight:600;font-size:13px;color:#1a2140;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.4;"]);
var TypeText = styled.div.withConfig({
  displayName: "attachment-itemcomponent__TypeText",
  componentId: "sc-1ey21cr-4"
})(["font-size:10px;color:#8b95b0;text-transform:uppercase;line-height:1.4;margin-top:2px;"]);
var DescriptionText = styled.div.withConfig({
  displayName: "attachment-itemcomponent__DescriptionText",
  componentId: "sc-1ey21cr-5"
})(["font-size:11px;color:#8b95b0;line-height:1.4;margin-top:2px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
var RemoveButton = styled.button.withConfig({
  displayName: "attachment-itemcomponent__RemoveButton",
  componentId: "sc-1ey21cr-6"
})(["position:absolute;right:8px;top:", ";transform:", ";display:flex;align-items:center;justify-content:center;width:20px;height:20px;padding:0;border:none;background:transparent;color:#9aa4c2;border-radius:4px;cursor:pointer;transition:all 0.2s ease;&:hover{color:#5a6acf;background:#eef1fb;}svg{font-size:10px;}"], function (_ref4) {
  var $variant = _ref4.$variant;
  return $variant === 'compact' ? '50%' : '8px';
}, function (_ref5) {
  var $variant = _ref5.$variant;
  return $variant === 'compact' ? 'translateY(-50%)' : 'none';
}); // ─── Component ────────────────────────────────────────────────────────────────

export var AttachmentItemComponent = function AttachmentItemComponent(_ref6) {
  var _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'compact' : _ref6$variant,
      icon = _ref6.icon,
      _ref6$iconColor = _ref6.iconColor,
      iconColor = _ref6$iconColor === void 0 ? styleVariables.colors.colorPrimaryBase : _ref6$iconColor,
      type = _ref6.type,
      name = _ref6.name,
      description = _ref6.description,
      url = _ref6.url,
      onRemove = _ref6.onRemove;
  var isRich = variant === 'rich';
  var isClickable = isRich && Boolean(url);

  var handleCardClick = function handleCardClick() {
    if (!isClickable || !url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  var handleRemoveClick = function handleRemoveClick(e) {
    e.stopPropagation();
    onRemove();
  };

  var titleNode = /*#__PURE__*/_jsx(TitleText, {
    children: name
  });

  return /*#__PURE__*/_jsxs(ItemWrapper, {
    $variant: variant,
    $clickable: isClickable,
    onClick: isClickable ? handleCardClick : undefined,
    role: isClickable ? 'button' : undefined,
    tabIndex: isClickable ? 0 : undefined,
    onKeyDown: isClickable ? function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleCardClick();
      }
    } : undefined,
    children: [/*#__PURE__*/_jsx(IconContainer, {
      $color: iconColor,
      children: icon
    }), /*#__PURE__*/_jsxs(ContentColumn, {
      children: [!isRich && url ? /*#__PURE__*/_jsx(Tooltip, {
        title: url,
        placement: "topLeft",
        mouseEnterDelay: 0.5,
        children: titleNode
      }) : titleNode, isRich ? description ? /*#__PURE__*/_jsx(DescriptionText, {
        children: description
      }) : null : type ? /*#__PURE__*/_jsx(TypeText, {
        children: type
      }) : null]
    }), /*#__PURE__*/_jsx(RemoveButton, {
      $variant: variant,
      type: "button",
      onClick: handleRemoveClick,
      "aria-label": "Remove attachment",
      children: /*#__PURE__*/_jsx(CloseOutlined, {})
    })]
  });
};